export default "__VITE_ASSET__D2hw47gt__"